import type { NavigationGuard } from 'vue-router'
import { routeParamToString, toTenantAdminPath, toTenantPath } from '@/utils/tenantRoute'

export const legacyTenantRedirect: NavigationGuard = (to) => {
  const target = toTenantPath(to.fullPath)
  return target !== to.fullPath ? target : true
}

export const legacyAdminTenantRedirect: NavigationGuard = (to) => {
  const target = toTenantAdminPath(to.fullPath)
  return target !== to.fullPath ? target : true
}

export function tenantScopedRedirect(path: string) {
  return (to: { params?: Record<string, unknown> }) => toTenantPath(path, routeParamToString(to.params?.tenantCode))
}

export function maybeRouteName(withNames: boolean, name: string) {
  return withNames ? { name } : {}
}
